import { Product, useGetOneProduct } from "src/api/client-api/products/useGetOneProduct";
import { IngredientCompletionService, IngredientSummaryData } from "./Ingredients/IngredientCompletionService";
import { useGetSomeIngredientReference } from "src/api/sure-api/ingredientReference/useGetSomeIngredientReference";
import { useGetIngredientsPosts } from "src/api/client-api/post/useGetIngredientsPosts";
import { Ssq } from "src/api/sure-api/ssq/useGetOneSsq";
import { Post } from "src/api/client-api/post/postSchema";
import { useEntityBasedScoreParams } from "src/context/EntityBasedScore/useEntityBasedScoreParams";
import { Scores } from "src/api/client-api/post/scoreSchema";

type Options = {
    product: Product | undefined;
    ssq: Ssq | undefined;
    post: Post | undefined;
    campaignId: number | undefined;
    selectedScoreId: number;
};

export type ProductSummary = {
    product: {
        completion: number;
        count: number;
    };
    ingredients: IngredientSummaryData;
    summaryScores: Scores | undefined;
};
export const useProductSummaryData = (options: Options): ProductSummary => {
    const { ssq, post, campaignId, selectedScoreId } = options;

    const entityParams = useEntityBasedScoreParams({
        campaign: campaignId,
        initDimensions: { dimensions: [["components"], ["ingredients"]] },
    });
    const { product: summaryScores } = useGetOneProduct(options.product?.id, {
        scoreQuery: entityParams.query,
    });

    const ingredientIds = (options.product?.productIngredients ?? []).map((pi) => pi.ingredient.id);
    const { posts: ingredientPosts } = useGetIngredientsPosts(ingredientIds, campaignId);

    const irid = options.product?.productIngredients
        ?.map((pi) => pi.ingredient.ingredientReferenceId)
        .filter((i) => i !== undefined);
    const { data: ingredientReferences } = useGetSomeIngredientReference(irid);

    const totalCompletion = ssq && post ? post.completions.ssq.result : 0;

    const ingredientCompletion = IngredientCompletionService.calculateTotalCompletionRates(
        options.product?.productIngredients ?? [],
        ingredientPosts,
        ingredientReferences,
        selectedScoreId,
    );

    const summary = {
        product: {
            completion: totalCompletion,
            count: 1,
        },
        ingredients: ingredientCompletion,
        summaryScores: summaryScores?.scores,
    };

    return summary;
};
